import React, { memo } from 'react';
import { Info } from '@app/components';
import { useTranslation } from 'react-i18next';
import { Company } from '@app/models';
import { fullName } from '@app/helpers';

interface Props {
  company?: Company;
}

function ProfileCompanyInfo(props: Props) {
  const { company } = props;
  const { t } = useTranslation();

  if (!company)
    return <div>{t('notSpecified') || 'Нет данных о компании'}</div>;

  return (
    <div className="flex flex-col gap-2 w-full">
      <Info
        label="Наименование организации"
        value={company.name || t('notSpecified')}
      />
      <Info label="БИН партнера" value={company.bin || t('notSpecified')} />
      <Info
        label="Директор"
        value={
          company.owner
            ? fullName(company.owner)
            : t('notSpecified') || 'Нет данных о директоре'
        }
      />
      <Info
        label="Регион"
        value={company.kato ? company.kato.nameRu : t('notSpecified')}
      />
      <Info
        label="Юридический адрес"
        value={company.legalAddress || t('notSpecified')}
      />
      <Info
        label="Фактический адрес"
        value={company.address || t('notSpecified')}
      />
    </div>
  );
}

export default memo(ProfileCompanyInfo);
